import Model from "./Model";
import User from "./User";

export default class SimulationMetadata extends Model {
  service1!: Record<string, string>;
  service2!: Record<string, string>;
  service3!: Record<string, string>;
}
